import { render } from "./ActiveReport.vue?vue&type=template&id=93e6cc14&ts=true"
import script from "./ActiveReport.vue?vue&type=script&lang=ts"
export * from "./ActiveReport.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__